/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CloudStatePendingIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Cloud State Pending',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M16.23535,14.64551c-.09375,0-.18945-.02148-.2793-.06543l-1.23535-.61621c-.21191-.10645-.3457-.32227-.3457-.55957v-1.91504c0-.34473.28027-.625.625-.625s.625.28027.625.625v1.52832l.88965.44336c.30859.1543.43359.5293.28027.83887-.10938.21875-.33105.3457-.55957.3457Z"
      fill="currentColor"
    />
    <path
      d="M18.97949,14.58301c-.02637,0-.05176-.00098-.07812-.00391-.41211-.04297-.71191-.41113-.66895-.82324.00781-.07031.01172-.14062.01562-.21094.01953-.41309.36035-.75391.78418-.71387.41309.01953.7334.37012.71387.78418-.00391.09766-.01172.19531-.02148.29492-.04004.38574-.36523.67285-.74512.67285Z"
      fill="currentColor"
    />
    <path
      d="M15,18.1582c-2.61914,0-4.75-2.13086-4.75-4.75,0-1.91309,1.13867-3.63086,2.90137-4.37598.37793-.16309.82129.0166.98242.39844.16211.38086-.0166.82129-.39844.98242-1.20605.51074-1.98535,1.68652-1.98535,2.99512,0,1.79199,1.45801,3.25,3.25,3.25.94336,0,1.83887-.4082,2.45703-1.12109.27246-.31348.74609-.3457,1.05762-.0752.31348.27148.34668.74512.0752,1.05762-.90234,1.04102-2.21094,1.63867-3.58984,1.63867Z"
      fill="currentColor"
    />
    <path
      d="M9,16.99805H3.71777c-1.90332,0-3.45215-1.54785-3.45215-3.45117,0-1.49219.9668-2.78027,2.32422-3.25-.04297-.23145-.06445-.46582-.06445-.70312,0-2.17969,1.80957-3.95215,4.0332-3.95215.2793,0,.55762.0293.83105.08789.6377-1.95898,2.47656-3.34766,4.58887-3.34766,2.49609,0,4.56738,1.87012,4.81836,4.35059.04199.41211-.25879.7793-.6709.82129-.40723.0498-.7793-.25781-.82129-.6709-.17285-1.71094-1.60352-3.00098-3.32617-3.00098-1.66309,0-3.08008,1.25195-3.29688,2.91211-.03125.23535-.17188.44238-.37891.55762-.20898.11719-.45801.125-.6748.02832-.34863-.1582-.70898-.23828-1.06934-.23828-1.39648,0-2.5332,1.09961-2.5332,2.45215,0,.33203.06934.65625.20605.96484.09961.22363.08301.48242-.04395.69238s-.34863.34375-.59375.35938c-1.02539.06641-1.82812.91699-1.82812,1.93652,0,1.07617.87598,1.95117,1.95215,1.95117h5.28223c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M16.11719,10.31836c-.06934,0-.14062-.00977-.21094-.03027-.06445-.01855-.13086-.03613-.19824-.05078-.40039-.08984-.67578-.49023-.59082-.89258.08594-.40137.4541-.66309.86035-.58398.00684.00098.05566.01172.06348.01367.09375.02051.19141.0459.28711.07422.39746.11621.625.5332.50879.93066-.0957.32715-.39453.53906-.71973.53906Z"
      fill="currentColor"
    />
    <path
      d="M18.32324,11.93066c-.24219,0-.48047-.11719-.625-.33398-.03809-.05664-.07715-.11133-.11816-.16504-.25195-.3291-.19043-.7998.1377-1.05176.33105-.25195.7998-.19043,1.05176.1377.0625.08105.12012.16309.17676.24707.22949.34473.13672.81055-.20801,1.04004-.12793.08496-.27246.12598-.41504.12598Z"
      fill="currentColor"
    />
  </svg>`;
};
